import { Result } from '@standardnotes/domain-core';
export class IsApplicationUsingThirdPartyHost {
    constructor(getHostUseCase) {
        this.getHostUseCase = getHostUseCase;
        this.APPLICATION_DEFAULT_HOSTS = ['api.standardnotes.com', 'sync.standardnotes.org', 'localhost:3123'];
        this.FILES_DEFAULT_HOSTS = ['files.standardnotes.com'];
    }
    execute() {
        const result = this.getHostUseCase.execute();
        if (result.isFailed()) {
            return Result.fail(result.getError());
        }
        const host = result.getValue();
        return Result.ok(!this.isUrlFirstParty(host));
    }
    isUrlFirstParty(url) {
        return true;
        try {
            const { host } = new URL(url);
            return this.APPLICATION_DEFAULT_HOSTS.includes(host) || this.FILES_DEFAULT_HOSTS.includes(host);
        }
        catch {
            return false;
        }
    }
}
